<div class="descriptions-container">
  <!-- Pro -->
  <div class="package-description-container flex flex-col">
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        [packageType]="subscriptionsPlanType.Pro"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+BOOKING.PLAN.PRO.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+BOOKING.PLAN.PRO.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>
    <div class="feature-description-container margined flex flex-row gap-[24px] lt-md:!hidden">
      <div class="flex flex-col flex-[100%] max-w-[33%]">
        <h4>{{ '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.TITLE' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.permanentInspectionDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[33%]">
        <h4>{{ '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.predictiveMaintenanceDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[33%]">
        <h4>{{ '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.automatedRecommendationsDetails"
        ></app-translate-list>
      </div>
    </div>
    <div class="feature-description-container flex flex-col gap-[24px] lt-md:!hidden">
      <h2>{{ '+BOOKING.PLAN.FEATURE.INCLUDED_FUNCTIONS' | translate }}</h2>
      <div class="flex flex-row gap-[24px] flex-[100%] max-h-[100%]">
        <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
          <app-translate-list
            [list]="flatBookingPlansSpecification.includedFunctionsDetails_PartOne"
          ></app-translate-list>
        </div>
        <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
          <app-translate-list
            [list]="flatBookingPlansSpecification.includedFunctionsDetails_PartTwo"
          ></app-translate-list>
        </div>
        <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
          <app-translate-list
            [list]="flatBookingPlansSpecification.includedFunctionsDetails_PartThree"
          ></app-translate-list>
        </div>
      </div>
    </div>

    <div class="feature-description-container flex flex-row gap-[24px] lt-md:!hidden">
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+FLAT_BOOKING.PLAN.PRO.SPEC.PARAMETERS.TITLE' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.parameterDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+FLAT_BOOKING.PLAN.FEATURE.PARAMETER_COMPARISON' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.parameterComparisonDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+FLAT_BOOKING.PLAN.FEATURE.DATA_LOGGING' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.dataLoggingDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+FLAT_BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.systemOverviewDetails"
        ></app-translate-list>
      </div>
    </div>
    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.PRO.SPEC.PERMANENT_INSPECTION.TITLE' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="flatBookingPlansSpecification.permanentInspectionDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="flatBookingPlansSpecification.predictiveMaintenanceDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="flatBookingPlansSpecification.automatedRecommendationsDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h2>{{ '+BOOKING.PLAN.FEATURE.INCLUDED_FUNCTIONS' | translate }}</h2>
        </mat-expansion-panel-header>
        <div class="flex flex-col">
          <div class="flex flex-row gap-[24px] flex-[100%] max-h-[100%]">
            <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
              <app-translate-list
                [list]="flatBookingPlansSpecification.includedFunctionsDetails_PartOne"
              ></app-translate-list>
            </div>
            <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
              <app-translate-list
                [list]="flatBookingPlansSpecification.includedFunctionsDetails_PartTwo"
              ></app-translate-list>
            </div>
            <div class="flex flex-col flex-[100%] gt-md:max-w-[33%] lt-md:max-w-[100%]">
              <app-translate-list
                [list]="flatBookingPlansSpecification.includedFunctionsDetails_PartThree"
              ></app-translate-list>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <!-- Basic -->
  <div class="package-description-container flex flex-col">
    <div class="package-description-title flex flex-row">
      <app-booking-package-badge
        [packageType]="subscriptionsPlanType.Basic"
      ></app-booking-package-badge>
      <div class="flex flex-col">
        <h3>
          {{ '+BOOKING.PLAN.BASIC.SPEC.TITLE' | translate }}
        </h3>
        <vi-text color="light">
          {{ '+BOOKING.PLAN.BASIC.SPEC.SUBTITLE' | translate }}
        </vi-text>
      </div>
    </div>
    <div class="feature-description-container flex flex-row gap-[24px] lt-md:!hidden">
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.quickCheckDashboardDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.guidedCommissioningDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.errorListDetails"
        ></app-translate-list>
      </div>
      <div class="flex flex-col flex-[100%] max-w-[25%]">
        <h4>{{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}</h4>
        <app-translate-list
          [list]="flatBookingPlansSpecification.basicParametersDetails"
        ></app-translate-list>
      </div>
    </div>
    <mat-accordion togglePosition="before" class="!hidden lt-md:!block">
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="flatBookingPlansSpecification.quickCheckDashboardDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="flatBookingPlansSpecification.guidedCommissioningDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="flatBookingPlansSpecification.errorListDetails"
        ></app-translate-list>
      </mat-expansion-panel>
      <mat-expansion-panel class="feature-description-container">
        <mat-expansion-panel-header>
          <h4>{{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}</h4>
        </mat-expansion-panel-header>
        <app-translate-list
          [list]="flatBookingPlansSpecification.basicParametersDetails"
        ></app-translate-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
